import { Component, OnInit, Input, Injector, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AbpSessionService } from 'abp-ng2-module';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { CompanyProfileCreateOrEditDto, CompanyProfileServiceProxy, OutlookCalendarServiceProxy, UserLoginServiceProxy, UserServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { AppConsts } from '@shared/AppConsts';
import { OffcanvasOptions } from '@metronic/app/core/_base/layout/directives/offcanvas.directive';
import { AppSessionService } from '@shared/common/session/app-session.service';

@Component({
  selector: 'app-setting-topbar',
  templateUrl: './setting-topbar.component.html',
  styleUrls: ['./setting-topbar.component.scss']
})
export class SettingTopbarComponent extends AppComponentBase implements OnInit, OnDestroy {
    imagePath: string;
    profilePicture: string;
    companyName = '';
    companyProfile: CompanyProfileCreateOrEditDto = new CompanyProfileCreateOrEditDto();
    @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean mr-1 mt-0';
    @Input() isDropup = false;
    mySubscription: any;
    isLoginForFirstTime: boolean = false;
    checkLogin: string;
    webAppVersion:string;


    constructor(private router: Router,
        private _companyProfilesServiceProxy: CompanyProfileServiceProxy,
        private outlookCalendar: OutlookCalendarServiceProxy,
        private _abpSession: AbpSessionService,
        private _userServiceProxy: UserServiceProxy,
        public _appSession: AppSessionService,

        private _userLoginAppService: UserLoginServiceProxy,
        injector: Injector) {
        super(injector);

        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };

        this.mySubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.router.navigated = false;
            }
        });
    }
    ngOnDestroy() {
        if (this.mySubscription) {
            this.mySubscription.unsubscribe();
        }
    }



    ngOnInit(): void {

        let thisObj = this;
        //this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess')) == undefined || JSON.parse(localStorage.getItem('checkLoginSuccess')) === true ? false : true;
        abp.event.on('checkLoginForTopbarSetting', function () { thisObj.userQuickStartDetailsCheckSetting(); });
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));

        //this.profilePicture = '../../../assets/common/images/Company profile-Default image.svg';
        //this.imagePath = ' ';
        //this.getCompanyProfileImg();
        //this.getCompanyProfileDetails(); //when router link changes this method call and multiple api call in backend.
    }


    userQuickStartDetailsCheckSetting() {
        this.webAppVersion= this._appSession.webAppVersion;

        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }


    updateInfoForCompanyProfile() {
        if (!AppConsts?.companyDetails) {
            if (abp.session.tenantId) {
                this._companyProfilesServiceProxy.getCompanyProfileDetailsForEditView(abp.session.tenantId).subscribe(x => {
                    if (x.companyImgURL !== null || x.companyImgURL !== undefined) {
                        this.profilePicture = x.companyImgURL;
                        this.companyImgURL = x.companyImgURL;
                    }
                    this.companyName = x.companyName;
                    AppConsts.companyDetails = x;
                });
            }

            else {
                this._companyProfilesServiceProxy.getCompanyProfileDetailsForEditView(undefined).subscribe(x => {
                    if (x.companyImgURL !== null || x.companyImgURL !== undefined) {
                        this.profilePicture = x.companyImgURL;
                        this.companyImgURL = x.companyImgURL;
                    }
                    this.companyName = x.companyName;
                    AppConsts.companyDetails = x;
                });
            }
        } else {
            if (AppConsts?.companyDetails.companyImgURL !== null || AppConsts?.companyDetails.companyImgURL !== undefined) {
                this.profilePicture = AppConsts?.companyDetails.companyImgURL;
                this.companyImgURL = AppConsts?.companyDetails.companyImgURL;
            }
            this.companyName = AppConsts?.companyDetails.companyName;
        }
    }

    companyImgURL:string = null;
    getCompanyProfileDetails() {
        if (!AppConsts?.companyDetails) {
            this._companyProfilesServiceProxy.getCompanyProfileDetailsForEditView(this._abpSession.tenantId).subscribe(res => {
            this.companyImgURL = res.companyImgURL; AppConsts.companyDetails = res;
            });
        } else {
            this.companyImgURL = AppConsts?.companyDetails?.companyImgURL;
        }
    }

    getCompanyProfileImg() {
        this._companyProfilesServiceProxy.getAllCompanyProfile().subscribe(res => {

            this.companyProfile = res;
            this.profilePicture = '';
            if (res.companyLogoURL !== undefined) {
                this.profilePicture = res.companyLogoURL;
            }
            this.companyProfile.dateFormat = res.dateFormat;
            this.companyProfile.id = res.id;
        });
    }
    addNewUser() {
        this.router.navigate(['/app/admin/users']);
    }
    getCompanyProfile() {
        this.router.navigate(['app/company-profile/company-profile']);
    }
    // getProductAndService() {
    //     this.router.navigate(['app/main/products-and-services']);
    // }
    getProductAndServiceNew() {
        this.router.navigate(['app/main/products-and-services-new']);
    }


    getOrganizationUnit() {
        this.router.navigate(['/app/admin/organization-units']);
    }

    getMangeUser() {
        this.router.navigate(['/app/admin/users-Master']);
    }
    getAppCategory() {
        this.router.navigate(['/app/main/appCategory']);
    }
    getMasters() {
        this.router.navigate(['/app/main/masters']);
    }

    // activateMSOutlook(){

    //     var response = this.outlookCalendar.getAuthorizationRequestUrl(undefined).subscribe(r => window.open(r.outlookAuthUrl, '_self'));
    //      ;
    // }

    imageLoad(){
        //this.getCompanyProfileDetails();
    }
}
